<div class="body none" [ngClass]="{'bodyscroll': isVisible}">
    <!-- <mat-spinner></mat-spinner> -->
    <!-- <div class="space rotating">
        <div class="space2">
            <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/eureka_bg-min.png" alt="">
        </div>
    </div> -->
    <!-- <span class="grad"></span> -->

    <!-- NAVBAR -->
    <div class="nav-home" *ngIf="!isVisible">
    <app-landnavbar></app-landnavbar>
    </div>
    <!-- <img src="assets/images/hero.webp" class="hero-image"> -->
    <!-- MAIN start-->
    <div class="laptop" style="overflow: hidden;">
        <!-- <video loop autoplay style="height: 100%; position: absolute;">
      <source src="../../../assets/eueka_front_4.gif" type="gif">
    </video> -->
    <!-- <img style="width: 100%;bottom:-25px; position: absolute;" src="https://eureka2022.s3.ap-south-1.amazonaws.com/river.png" alt=""> -->
</div>
    <!-- <div><img src="../../../assets/eueka_front_4.gif" alt="Be patient..." /></div> -->

    <!-- <div *ngIf="screen" class="landinghead parallax-zoom">
        <img src="assets/zonals/bg2.webp">
    </div>
    <div *ngIf="!screen" class="landinghead parallax-zoom">
        <img src="assets/zonals/bgmobile.webp">
    </div> -->
      <div class="logo" [ngClass]="{'logovisible': isVisible}">
        <div class="image">
            <img src="assets/images/eurekalogo.png" alt="">
        </div>
        <div class="content">
            <h2 class="prize prize1" style="margin-top: 20px;">Asia's largest business model competition</h2>
      <div style="display: flex; margin: auto; justify-content: center;">
          <h2 style="padding-right: 10px;" class="prize font">Cash prizes of</h2><h2 class="prize font" style="color: #8eb3df;"> INR 1 Cr+</h2>
      </div>
      <div class="butbut">
        <button [routerLink]="['/reg']" type="button" class="btn btn-lg inverse">Register Now</button>
        <button (click)="onregister()" type="button" class="btn btn-lg trans">Login</button>
    </div>
        </div>
      </div>
      <div class="regform" *ngIf="isVisible">
        <app-prereg></app-prereg>
      </div>
    <div class="main container" style="display: none;">
      <div class="content">
      <!-- <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/eureka_logo_final.png" alt=""> -->
      <!-- <div class="texts">
          <h2>ASIA’S LARGEST BUSINESS MODEL COMPETITION</h2>
          <h2>PRIZES WORTH 1 CRORE</h2>
      </div> -->
      <h2 class="prize" style="margin-top: 20px;">Asia's largest business model competition</h2>
      <div style="display: flex; margin: auto; justify-content: center;">
          <h2 style="padding-right: 10px;" class="prize font">Cash prizes of</h2><h2 class="prize font" style="color: #8eb3df;"> INR 1 Cr+</h2>
      </div>
      <!-- <div *ngIf="isLoggedin; else loggedOut">
      <div class="butbut">
          <button [routerLink]="['/db']" type="button" class="btn btn-lg btn-success">Dashboard</button>
          <button (click)="logout()" type="button" class="btn btn-primary btn-lg btn-primary">Logout</button>
      </div>
      </div> -->
      
      <div>
        <div class="butbut">
            <button [routerLink]="['/reg']" type="button" class="btn btn-lg btn-success inverse">Register Now</button>
            <button (click)="check()" type="button" class="btn btn-success btn-lg trans">Login</button>
        </div>
      </div>
      </div>
  </div>
  <!-- MAIN END -->
  <!-- WHAT IS EUREKA START -->
  <div class="boxy" style="padding-bottom: 40px; background: url(assets/images/stars2bg.webp); background-size: contain;">
      <!-- <span class="back-line"><img src="assets/images/back-line.png"></span> -->
      <div class="container-fluid what-eureka">
          <div class="whatis">
            <h3>What is Eureka?</h3>
          <p>
            Unleash your innovation and fulfill your entrepreneurial dreams at Eureka!, Asia’s largest Business Model Competition. Instated 25 years ago with a vision to nurture great ideas towards the path of glaring success, Eureka! offers a platform for aspiring entrepreneurs to showcase their innovative ideas and accelerate their journey towards commercial success.
          </p>
          </div>
          <div class="whatisimage" style="background: url(assets/zonals/eurekaland.jpg); background-size: cover;">
            <!-- <img src="assets/eureka_bg-min.png" class="eurekaimg" alt=""> -->
          </div>
      </div>
      <!-- <div class="container-fluid vision why">
          <h3>Vision</h3>
          <p>
              Innovation and entrepreneurship are the driving forces that will steer the world into a brighter future. Great ideas, if nurtured, can pave the way for glaring success. To facilitate this vision, Eureka! provides a platform for potential ideas and early-stage startups to develop in a risk-free environment. It aims to bridge the gap between idea and enterprise, and make the journey between the two seamless.
          </p>
      </div> -->
      <div>
        <div class="container-fluid why">
            <div>
                <!-- <div class="title">
                    <h2>TITLE 01</h2>
                </div> -->
                <div class="stats">
                    <div class="statcards">
                        <div class="statsimg">
                            <img src="assets/eurekacards/entries.png" alt="">
                        </div>
                        <div class="statsnumbers">
                            <h2>12,500+</h2>
                        </div>
                        <div class="statsname">
                            <h2>ENTRIES</h2>
                        </div>
                    </div>
                    <div class="statcards">
                        <div class="statsimg">
                            <img src="assets/eurekacards/mentors.png" alt="">
                        </div>
                        <div class="statsnumbers">
                            <h2>200+</h2>
                        </div>
                        <div class="statsname">
                            <h2>MENTORS</h2>
                        </div>
                    </div>
                    <div class="statcards">
                        <div class="statsimg">
                            <img src="assets/eurekacards/prizes.png" alt="">
                        </div>
                        <div class="statsnumbers">
                            <h2>80 Lakhs</h2>
                        </div>
                        <div class="statsname">
                            <h2>WORTH PRIZES</h2>
                        </div>
                    </div>
                    <div class="statcards">
                        <div class="statsimg">
                            <img src="assets/eurekacards/legacy.png" alt="">
                        </div>
                        <div class="statsnumbers">
                            <h2>26th</h2>
                        </div>
                        <div class="statsname">
                            <h2>EDITION</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <div class="container-fluid vision">
              <!-- <h3 class="why2">Why Eureka?</h3> -->
              <div class="title">
                <h1><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">Why Eureka?</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
              </div>
              <div class="benefitcards">
                <app-eurekacards></app-eurekacards>
              </div>
              <!-- <div class="benefitcards">
                <div class="whycard">
                    <div class="whyimg">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/whyeureka/networking.png" alt="">
                    </div>
                    <div class="pro">
                        <h2>
                            Networking
                        </h2>
                        <p>Exclusive access to offline events across India to network with investors and startups</p>
                    </div>
                </div>
                
                <div class="whycard">
                    <div class="whyimg">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/whyeureka/cash.png" alt="">
                    </div>
                    <div class="pro">
                        <h2>
                            INR 1.2 CR+ Worth Prizes
                        </h2>
                        <p>Get access to INR 65L+ cash prize and world class resources worth INR 50L+</p>
                    </div>
                </div>
                <div class="whycard">
                    <div class="whyimg">
                        <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/whyeureka/networking2.png" alt="">
                    </div>
                    <div class="pro">
                        <h2>
                            One on one Mentoring
                        </h2>
                        <p>Prolonged 1 on 1 mentoring with industry experts and startup mentors</p>
                    </div>
                </div>
          </div> -->
    
          <!-- <div class="container-fluid gallery">
              <div class="row">
                  <div class="col-3" *ngFor="let lis of list">
                      <img src="{{lis.img}}">
                  </div>
              </div>
              <div class="row left">
                  <div class="col-3" *ngFor="let lis of list2">
                      <img src="{{lis.img}}">
                  </div>
              </div>
          </div> -->
          <!-- <app-stats></app-stats> -->
          <!-- <input type="text" ng2TelInput [ng2TelInputOptions]="{initialCountry: 'in'}" (ng2TelOutput)="getNumber($event)" (countryChange)="onCountryChange($event)" name="contact" [(ngModel)] ="contact"/> -->
          <!-- <div class="container-fluid what-eureka">
            <h3 style="text-align: center;">Social impact of Eureka!</h3>
            <p>
                Eureka! provides a platform for early-stage social entrepreneurs in India to nurture their ideas and grow as true creators of change. Various investors and associates helped us over the years to achieve this mission. Eureka! has created some notable startups are:        
              </p>
        </div> -->
        </div>
      </div>
    <div class="structure">
        <div class="title" style="margin: 7rem 3rem;">
            <h1><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">Structure</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
          </div>
        <app-structure></app-structure>
      </div>
    <div class="zonals">
        <div class="title" style="margin: 3rem;">
            <h1><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">Gallery</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
          </div>
        <app-zonals></app-zonals>
      </div>
    <div class="testimonial">
        <div class="title" style="margin: 7rem 3rem;">
            <h1><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">Testimonials</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
          </div>
        <app-landtesti style="position: relative;"></app-landtesti>
    </div>
  <div class="boxy" style="padding-bottom: 40px;">
    <!-- <span class="back-line"><img src="assets/images/back-line.png"></span> -->
    <!-- <div class="container-fluid vision2">
        <div class="benefitcards">
          <div class="whycard2">
              <div class="whyimg">
                  <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/startups/Aakar.webp" alt="">
              </div>
          </div>
          
          <div class="whycard2">
              <div class="whyimg">
                  <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/startups/dehaat.png" alt="">
              </div>
          </div>
          <div class="whycard2">
              <div class="whyimg">
                  <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/startups/socialcops.png" alt="">
              </div>
          </div>
    </div>
  </div>
    <div class="container-fluid vision2">
        <div class="benefitcards">
          <div class="whycard3">
            <p style="font-size:22px; ">Social Track Sponsor</p>
              <div class="whyimg2">
                 <a href="https://www.unionbankofindia.co.in/english/home.aspx" target="_blank"><img src="https://eureka2022.s3.ap-south-1.amazonaws.com/startups/logo.webp" alt=""></a> 
              </div>
          </div>
    </div>
  </div> -->
  <app-footer></app-footer>
  <!-- <div>
    <div class="mainx"  style="position: relative;">
        <div class="foot">
            <div class="row-1">
                <a href="https://www.ecell.in/" target="_blank"><img src="https://eureka2022.s3.ap-south-1.amazonaws.com/ecell-logo2.png" alt=""></a>
                <p class="phone">E-Cell IIT Bombay is Asia’s Largest
                    Entrepreneurship promoting student
                    body and we build startup ecosystem
                    on both the sides of the wall </p>
                <h4>CREATING JOB CREATORS</h4>
            </div>
            <div class="row-3 phone">
                <div style="width: 50%;" class="quick-links">
                    <h3>QUICK LINKS</h3>
                    <a href="https://www.ecell.in/esummit22/" target="_blank"><h4>E-Summit</h4></a>
                    <a href="https://www.ecell.in/eureka/eurekagcc" target="_blank"><h4>Eureka! GCC</h4></a>
                    <a href="https://www.ecell.in/nec/" target="_blank"><h4>NEC</h4></a>
                    <a href="https://eureka.ecell.in/junior/" target="_blank"><h4>Eureka! Junior</h4></a>
                    <a href="https://www.ecell.in/enbclub/#page-2" target="_blank"><h4>EnB</h4></a>
                    <a href="https://www.ecell.in/ssp/" target="_blank"><h4>SSP</h4></a>
                </div>
                <div style="width: 50%;">
                    <h3>
                        REACH OUT
                    </h3>
                    <a href="https://goo.gl/maps/7JNM1Ax7w3QMH3jf7" target="_blank"><h4 class="address">
                        E-Cell Office <br>
                        Student Activity<br>
                        Centre (SAC)<br>
                        IIT Bombay<br>
                        Powai<br>
                        Mumbai, India<br>
                    </h4></a>
                    </div>
            </div>
            
        </div>
        <div class="foot-2">
            <div class="row-2">
                <h4 style="margin: 0px;">Contact Us:</h4>
                <h4 style=" margin-top:0px;margin-bottom:10px; font-size:18px;"><a href="mailto:eureka2022@ecell.in" target="_blank" style="color: white;"> eureka2022@ecell.in</a></h4>
            </div>
            <div class="socials">
                <h4  style="margin: 0px;">Follow Us:</h4>
                <div class="social">
                    <div><a href="https://www.facebook.com/ecell.in/" target="_blank"><i class="fa-brands fa-facebook-f fa-2xl"></i></a></div>
                    <div><a href="https://www.linkedin.com/company/ecell_iitb/" target="_blank"><i class="fa-brands fa-linkedin-in fa-2xl"></i></a></div>
                    <div><a href="https://www.instagram.com/iitbombay_ecell/" target="_blank"><i class="fa-brands fa-instagram fa-2xl"></i></a></div>
                    <div><a href="https://twitter.com/ecell_iitb" target="_blank"><i class="fa-brands fa-twitter fa-2xl"></i></a></div>
                    <div><a href="https://www.youtube.com/user/entrepreneurshipcell" target="_blank"><i class="fa-brands fa-youtube fa-2xl"></i></a></div>
                </div>
                <div class="social2">
                    <div><a href="https://www.facebook.com/ecell.in/" target="_blank"><i class="fa-brands fa-facebook-f"></i></a></div>
                    <div><a href="https://www.linkedin.com/company/ecell_iitb/" target="_blank"><i class="fa-brands fa-linkedin-in"></i></a></div>
                    <div><a href="https://www.instagram.com/iitbombay_ecell/" target="_blank"><i class="fa-brands fa-instagram"></i></a></div>
                    <div><a href="https://twitter.com/ecell_iitb" target="_blank"><i class="fa-brands fa-twitter"></i></a></div>
                    <div><a href="https://www.youtube.com/user/entrepreneurshipcell" target="_blank"><i class="fa-brands fa-youtube"></i></a></div>
                </div>
            </div>
            
        </div>
    </div>
</div> -->
</div>
